import axios from './axiosInstance'
import { isAuthenticated, getAuthHeader } from '../utils/authSession'

export default function init() {}

export async function getDistinctErrors(app, apiHost) {
  const protocol = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  const url = `${protocol}${apiHost}/v3/notifications/v1/logs/errors`

  try {
    if (isAuthenticated()) {
      const response = await axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          ...getAuthHeader(),
          apiKey: app.accessKey,
        },
      })
      return response.data
    }
  } catch (error) {
    return error.response?.data || { error: 'Failed to fetch distinct errors' }
  }
  return false
}

export async function getNotificationLogs(app, apiHost, paginationPayload = '', filters = {}) {
  const protocol = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  let url = `${protocol}${apiHost}/v3/notifications/v1/logs?limit=10${
    paginationPayload ? '&' : ''
  }${paginationPayload}`

  // Add messageId filter
  if (filters.messageId) {
    url += `&messageId=${encodeURIComponent(filters.messageId)}`
  }

  // Add sender filter (already comma-separated string from container)
  if (filters.sender) {
    url += `&sender=${encodeURIComponent(filters.sender)}`
  }

  // Add receiver filter (already comma-separated string from container)
  if (filters.receiver) {
    url += `&receiver=${encodeURIComponent(filters.receiver)}`
  }

  // Add receiverType filter
  if (filters.receiverType) {
    url += `&receiverType=${encodeURIComponent(filters.receiverType)}`
  }

  // Add channel filter (already comma-separated string from container)
  if (filters.channel) {
    url += `&channel=${encodeURIComponent(filters.channel)}`
  }

  // Add provider filter
  if (filters.provider) {
    url += `&provider=${encodeURIComponent(filters.provider)}`
  }

  // Add notificationTriggered filter
  if (filters.notificationTriggered) {
    url += `&notificationTriggered=${encodeURIComponent(filters.notificationTriggered)}`
  }

  // Add success filter
  if (filters.success) {
    url += `&success=${encodeURIComponent(filters.success)}`
  }

  // Add error filter (already comma-separated string from container)
  if (filters.error) {
    url += `&error=${encodeURIComponent(filters.error)}`
  }

  // Add reason filter
  if (filters.reason) {
    url += `&reason=${encodeURIComponent(filters.reason)}`
  }

  // Add trigger filter
  if (filters.trigger) {
    url += `&trigger=${encodeURIComponent(filters.trigger)}`
  }

  // Add date range filters
  if (filters.from) {
    url += `&from=${encodeURIComponent(filters.from)}`
  }
  if (filters.to) {
    url += `&to=${encodeURIComponent(filters.to)}`
  }

  try {
    if (isAuthenticated()) {
      const response = await axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          ...getAuthHeader(),
          apiKey: app.accessKey,
        },
      })
      return response.data
    }
  } catch (error) {
    return error.response?.data || { error: 'Failed to fetch notification logs' }
  }
  return false
}

export async function getFilterOptions(app, apiHost) {
  const protocol = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  const url = `${protocol}${apiHost}/v3/notifications/v1/logs/filters`

  try {
    if (isAuthenticated()) {
      const response = await axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          ...getAuthHeader(),
          apiKey: app.accessKey,
        },
      })
      return response.data
    }
  } catch (error) {
    console.error('Failed to fetch filter options:', error)
    return false
  }
  return false
}
